<template>
    <div class="py-2 px-2 my-2 border border-gray-200 flex w-full hover:bg-gray-100">
        <div class="p-1 w-full flex justify-between items-center">
            <div>
                <Link :href="route('advisors.option-sets.show', set.uuid)">
                    {{ set.name }} <span class="text-gray-500 text-sm hidden md:inline">({{ set.optionsAmount }}) {{
                        set.optionsAmount > 1 || set.optionsAmount < 1 ? $t("set.options") : $t("set.option")
                  }}<br> {{ $t("set.external") }}: {{
                        set.title
                    }} </span>
                </Link>
            </div>
            <div class="flex items-center">
                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                      :class="[set.state === 'active' ? 'bg-lime-100 text-lime-800' : 'bg-gray-100', 'text-gray-800']">
                    {{ $t("states." + set.state) }}
                </span>

                <button type="button">
                    <TrashIcon
                        v-if="set.deletable"
                        @click="$emit('delete', set)"
                        class="h-5 ml-4 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { PencilIcon, SearchIcon, TrashIcon, UserIcon } from "@heroicons/vue/outline";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    props: ["set"],
    emits: ["delete"],
    components: { UserIcon, PencilIcon, SearchIcon, TrashIcon, Link }
};
</script>

<style scoped></style>
